export default {
  methods: {
    $startPageLoading(msg) {
      this.$emit('startLoading', msg);
    },
    $endPageLoading() {
      this.$emit('endLoading');
    },
  },
};



// WEBPACK FOOTER //
// ./src/store/BFOPMixin.js